// extracted by mini-css-extract-plugin
export default {"subheading":"subheading-3Geya7","flush":"flush-3y9fVG"};